/**
 *  Canvasのレスポンシブ対応
 */
export default class ScrollingAnimationVideo {
  canvas;
  context;
  startPosElement;
  siteHeaderWrapperElm;
  // frameCount = 89; // 画像の枚数
  frameCount = 182; // 画像の枚数
  images = {
    pc: [],
    sp: []
  };

  imgWidth = 1280;
  imgHeight = 720;
  currentFrameIndex = 1;
  imgPath;
  currentDevice = 'pc';

  scrollAnimScopeElement;
  scrollAnimEndElement;
  addressBarHeight = 0;
  lastResizeEventNow = 0;

  imageSizePC = {
    width: 1280,
    height: 720
  };
  imageSizeSP = {
    width: 750,
    height: 1334
  }

  // TODO: 名前は本来「DevicePixelRatio」の方が良い
  retinaScale = 1;

  constructor() {
    this.canvas = document.getElementById("home-background-video");
    this.startPosElement = document.getElementById("main-visual");
    this.context = this.canvas.getContext("2d");
    this.siteHeaderWrapperElm = document.querySelector('#site-header-wrapper');

    // 同期アニメーションの対象範囲を指定
    this.scrollAnimScopeElement = document.querySelector("#main");

    // 同期アニメーション範囲内の最後の要素を指定
    this.scrollAnimEndElement = document.querySelector("#furniture");

    if ('undefined' !== typeof wpThemeUrl) {
      this.imgPath = wpThemeUrl + '/assets/images/home/';
    } else {
      this.imgPath = 'assets/images/home/';
    }

    // フレーム数の設定
    if ('undefined' !== typeof wpVideoBgFileCount) {
      this.frameCount = wpVideoBgFileCount;
    }

    // 画像サイズの設定
    if ('undefined' !== typeof wpVideoBgImageSize) {
      this.imageSizePC.width = wpVideoBgImageSize.width;
      this.imageSizePC.height = wpVideoBgImageSize.height;
    } else {
      this.imageSizePC.width = 1280;
      this.imageSizePC.height = 720;
    }

    if ('undefined' !== typeof wpVideoBgSpImageSize) {
      this.imageSizeSP.width = wpVideoBgSpImageSize.width;
      this.imageSizeSP.height = wpVideoBgSpImageSize.height;
    } else {
      this.imageSizeSP.width = 750;
      this.imageSizeSP.height = 1334;
    }

    this.setCurrentDevice();

    this.setRetinaScale();

    this.init();
  }

  isFacebookApp() {
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
  }

  async init() {
    // アドレスバーの高さ計算用の要素を取得
    const controlHeightElm = document.getElementById('control-height');

    // アドレスバーの高さを計算する
    this.addressBarHeight = Math.abs(window.innerHeight - controlHeightElm.clientHeight);

    // window.alert("window.innerHeight: " + window.innerHeight);
    // window.alert("controlHeightElm.clientHeight: " + controlHeightElm.clientHeight);

    // Canvasのサイズを調整
    this.setCanvasSize();

    /**
     * 事前に画像を読み込む。
     * 素早いスクロール時に描画ラグが発生するため。
     */
    await this.preloadImages();

    // 最初の画像を描画
    this.firstImageDraw();

    // スクロールイベントに画像描画を同期
    this.setScrollEventSync();

    // レスポンシブ対応
    this.setResponsive();
  }

  /**
   * Canvasのサイズと画像サイズを設定する
   */
  setCanvasSize() {
    // 画像サイズの設定
    if ('pc' === this.currentDevice) {
      this.imgWidth = this.imageSizePC.width;
      this.imgHeight = this.imageSizePC.height;

      // PC以上の場合はウィンドウ幅からヘッダー要素の横幅を引いた値を設定
      this.canvas.width = window.innerWidth - this.siteHeaderWrapperElm.clientWidth;
    } else {
      this.imgWidth = this.imageSizeSP.width;
      this.imgHeight = this.imageSizeSP.height;

      // スマホの場合はウィンドウ幅をそのまま設定
      this.canvas.width = window.innerWidth * this.retinaScale;
    }

    /**
     * window.innerHeightを使わないのはアドレスバーの高さが可変なため。
     * アドレスバーを含めたウィンドウ高さを設定する。
     */
    if (this.isFacebookApp()) {
      // Facebook内蔵ブラウザの場合はscreen.heightを使う
      this.canvas.height = (window.screen.height + this.addressBarHeight) * this.retinaScale;
    } else {
      this.canvas.height = (document.documentElement.clientHeight + this.addressBarHeight) * this.retinaScale;
    }
  }

  /**
   * スクロール時に動画アニメーションを同期する
   */
  setScrollEventSync = () => {
    const self = this;

    window.addEventListener('scroll', (e) => {
      let windowHeight = self.canvas.height;

      // Retinaなら高さを2分の1にする
      if (2 === self.retinaScale) {
        windowHeight = windowHeight / self.retinaScale;
      }
      // TODO: スクロール時はinnerHeightで高さを計算したい
      // スクロールアニメーションの範囲前なら処理をしない
      if (window.scrollY < self.scrollAnimScopeElement.offsetTop) return;

      // スクロールアニメーションが終了するスクロール量を計算
      let scrollAnimEndAmount = self.scrollAnimScopeElement.offsetTop + self.scrollAnimScopeElement.offsetHeight;

      // スクロールアニメーションの範囲後でも処理をしない
      if (window.scrollY > scrollAnimEndAmount) return;

      /**
       * スクロール量を取得。
       * スクロールアニメーションの範囲要素までの距離を引く。
       */
      const scrollTop = window.scrollY - self.scrollAnimScopeElement.offsetTop;

      // スクロール量の最大値を調整する値
      let maxScrollAmountAdjust = self.scrollAnimEndElement.offsetHeight;

      if ('pc' === this.currentDevice) {
        // タブレットの場合
        if (751 <= window.innerWidth && window.innerWidth <= 1079) {
          maxScrollAmountAdjust = (maxScrollAmountAdjust / 2) + (maxScrollAmountAdjust / 3.5);
        }
        // PCの場合
        else {
          maxScrollAmountAdjust = (maxScrollAmountAdjust / 6) + (maxScrollAmountAdjust / 5);
        }
      }

      /**
       * スクロール量の最大を計算する
       * document.documentElement.scrollHeight: 全体のスクロール量
       * window.innerHeight: 見えている範囲
       */
      // メインビジュアルの高さではなく、スクロール範囲までの距離を引くべき？
      // const maxScrollTop = document.documentElement.scrollHeight - window.innerHeight - self.startPosElement.offsetHeight;
      const maxScrollTop = document.documentElement.scrollHeight - windowHeight - self.startPosElement.offsetHeight - maxScrollAmountAdjust;

      // スクロール量の割合を計算（全体でどれだけスクロールしているか）
      const scrollFraction = scrollTop / maxScrollTop;

      // 最小の値を取得
      const frameIndex = Math.min(
        self.frameCount - 1,
        Math.ceil(scrollFraction * self.frameCount)
      );

      // 画像を描画
      requestAnimationFrame(() => self.updateImage(frameIndex));
    });
  }

  setCurrentDevice() {
    if (window.innerWidth >= 751) {
      this.currentDevice = 'pc';
    } else {
      this.currentDevice = 'sp';
    }
  }

  setRetinaScale() {
      // SPならretinaScaleを2にする
      this.retinaScale = 'sp' === this.currentDevice ? 2 : 1;
  }

  setResponsive() {
    const self = this;

    window.addEventListener('resize', async function () {
      // 現在のデバイス情報を更新（PC or SP）
      self.setCurrentDevice();

      self.setRetinaScale();

      /**
       * PC,SP用画像が読み込まれていなかったら再ロード
       * 既に読み込まれていたら即returnされる
       */
      await self.preloadImages();

      // キャンバス、画像サイズの再設定
      self.setCanvasSize();

      // 描画する画像の更新
      self.updateImage(self.currentFrameIndex);
    });
  }

  /**
   * 現在のフレームを取得
   * @param {*} index
   * @returns
   */
  currentFrame = (index) => {
    if ('pc' === this.currentDevice) {
      return `${this.imgPath}video_bg/video_bg-${index.toString().padStart(3, '0')}.webp`
    } else {
      return `${this.imgPath}video_bg_sp/yano_bg_sp-${index.toString().padStart(3, '0')}.webp`
    }
  }

  /**
   * 事前に画像の読み込み
   */
  preloadImages() {
    // 現在のデバイスの画像一覧が既に読み込まれているなら処理をしない
    if (0 !== this.images[this.currentDevice].length) return;

    const results = [];

    for (let i = 0; i < this.frameCount; i++) {
      results.push(this.loadImage(i));
    }

    return Promise.all(results);
  };

  loadImage(index) {
    return new Promise((resolve, reject) => {
      this.images[this.currentDevice][index] = new Image();

      // 読み込み完了時
      this.images[this.currentDevice][index].onload = () => resolve(this.images[this.currentDevice][index]);

      // 読み込み失敗時
      this.images[this.currentDevice][index].onerror = (error) => reject(error);

      // 画像の読み込み開始
      this.images[this.currentDevice][index].src = this.currentFrame(index, this.currentDevice);
    });
  }

  /**
   * 画像を描画する
   */
  firstImageDraw = () => {
    const self = this;

    // 画像の読み込みが終わったら画像を描画する
    self.updateImage(0);
  }

  updateImage = index => {
    const self = this;

    self.currentFrameIndex = index;
    self.imageDraw(self.images[self.currentDevice][index]);
  }

  /**
   * キャンバスに画像を描画する
   * @param {*} img
   */
  imageDraw(img) {
    const iw = this.imgWidth;
    const ih = this.imgHeight;
    const cw = this.canvas.width / this.retinaScale;
    const ch = this.canvas.height / this.retinaScale;

    // 縦か横の比率を取得する（大きい比率を採用する）
    let f = Math.max(cw / iw, ch / ih);

    let translateX = (cw - (f * iw));
    let translateY = (ch - (f * ih));

    // 半分にすると左右、上下で中央配置になる。
    // translateX /= 2;
    // translateY /= 2;

    // @see https://stackoverflow.com/questions/66560704/adjust-canvas-image-size-like-background-size-cover-and-responsive
    this.context.setTransform(
      /*     scale x */ f,
      /*      skew x */ 0,
      /*      skew y */ 0,
      /*     scale y */ f,
      /* translate x */ translateX,
      /* translate y */ translateY,
    );

    if ('sp' === this.currentDevice) {
      // スマホの場合はRetina用に2倍にする
      this.context.scale(2, 2);
    } else {
      this.context.scale(this.retinaScale, this.retinaScale);
    }

    let dx = 0;
    let dy = 0;

    // TODO: setTransFormを使わず下端に画像を揃え場合
    // dx = this.canvas.width - this.imgWidth;
    // dy = this.canvas.height - this.imgHeight;

    if (typeof img !== 'undefined') {
      this.context.drawImage(img, dx, dy);
    }
  }
}
